import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const appointmentLink = "https://nextcloud.managershop.com/index.php/apps/appointments/pub/39t5c1133b0ztr29/form";

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
    closeMenu();
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    closeMenu();
  };

  return (
    <motion.header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100" initial={{ y: -100 }} animate={{ y: 0 }}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" onClick={handleLogoClick} className="flex items-center">
            <img src="https://github.com/mike3011/Bilder/blob/main/3.png?raw=true" alt="K³ Logo" className="h-10 w-auto" />
          </a>
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('approach')} className="text-gray-600 hover:text-black font-medium transition-colors">Ansatz</button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-600 hover:text-black font-medium transition-colors">FAQ</button>
            <button onClick={() => scrollToSection('inqa')} className="text-azure-600 hover:text-azure-700 font-bold transition-colors">INQA-Coaching</button>
            <div className="h-6 w-px bg-gray-200 mx-2"></div>
            <div className="flex flex-col items-center">
              <a href={appointmentLink} target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-gray-800 transition-all">
                Erstgespräch buchen
              </a>
              <span className="text-[10px] text-gray-400 mt-1 uppercase tracking-wider font-bold">Kostenlos. Unverbindlich.</span>
            </div>
          </nav>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-black">
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="md:hidden bg-white border-t border-gray-100 p-6 shadow-xl">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('approach')} className="text-gray-600 py-2 text-lg font-medium text-left">Ansatz</button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-600 py-2 text-lg font-medium text-left">FAQ</button>
              <button onClick={() => scrollToSection('inqa')} className="text-azure-600 py-2 text-lg font-bold text-left">INQA-Coaching</button>
              <a href={appointmentLink} target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-4 rounded-lg text-center font-bold">
                Erstgespräch buchen
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;